interface FormattedNumberProps {
  value: number;
  locale?: Intl.LocalesArgument;
  currency?: Intl.NumberFormatOptions['currency'];
  style?: Intl.NumberFormatOptions['style'];
  suffix?: string;
}

export const FormattedNumber = ({
  value,
  locale = 'fr-FR',
  currency = 'EUR',
  style,
  suffix
}: FormattedNumberProps) => {
  const styleToUse: Intl.NumberFormatOptions['style'] = style
    ? style
    : currency
      ? 'currency'
      : 'decimal';

  const options: Intl.NumberFormatOptions = {
    style: styleToUse
  };

  if (styleToUse === 'currency') {
    options.currency = currency;
  }

  try {
    const formatted = Intl.NumberFormat(locale, options).format(value);
    return suffix ? `${formatted}${suffix}` : formatted;
  } catch (error) {
    console.error('Error formatting number:', error);
    return suffix ? `${String(value)}${suffix}` : String(value);
  }
};
